export default "__VITE_ASSET__9b7359c7__"